import React from 'react';
import contactImage from '../../assets/images/contact_img.webp';
import Art from '../Misc/Art';
import illustration from '../../assets/images/art_1.png';

function ContactHeader() {
    return (
        <>
            <div className="page-header position-relative">
                <div className="page-header-top">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8">
                                <h1 className="heading heading-very-large dark-1">
                                    Contact Dr. Mohammed Audu Rehab Centre
                                </h1>
                                <p className="paragraph dark-2" style={{ marginTop: '1rem' }}>
                                    If you or a loved one needs help, reach out to us for confidential support and guidance.
                                </p>
                                <p className="paragraph dark-2" style={{ marginTop: '0.5rem' }}>
                                    Phone: [Insert phone number] • Email: [Insert email address] • Location: Nigeria
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="page-header-bottom">
                    <div className="single-image">
                        <img src={contactImage} alt="contact-header" />
                    </div>
                </div>
                <Art art={illustration} type="3" />
            </div>
        </>
    );
}

export default ContactHeader;
